
































import { Vue, Component, Watch, Emit, Prop } from 'vue-property-decorator';
import AMSTable from '@/components/AMSTable.vue';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import request from '@/utils/request';
import { discountRule } from '@/utils/rules';
import { getProductCount } from '@/api/product';
@Component({
  components: {
    'ams-table': AMSTable,
  },
})
export default class AMSCustomerDiscount extends Vue {
  categoryHeaders = [
    {
      text: '商品分类',
      value: 'productCategoryId',
      sortable: false,
      align: 'left',
      width: 500,
      render: (h: Function, param: any) => {
        return h(AMSProduct, {
          props: {
            disableItems: this.selectedCategory(),
            value: param.row[param.keyName],
          },
          on: {
            input: (value: any) => {
              this.inputHandler(value, param);
            },
          },
        });
      },
    },
    {
      text: '关联商品数',
      value: 'count',
      sortable: false,
      align: 'right',
      width: 100,
    },
    { text: '折扣率', align: 'left', value: 'discountRate', sortable: false, isInputNumber: { type: 'isDiscountRate', symbol: '%' } },
    {
      text: '操作',
      value: 'actions',
      isActions: true,
      sortable: false,
      align: 'center',
    },
  ];
  productHeaders = [
    {
      text: '商品',
      value: 'productId',
      align: 'left',
      sortable: false,
      width: 500,
      render: (h: Function, param: any) => {
        return h(AMSSelectedProduct, {
          props: {
            items: param,
            selectedItems: this.showProductCategorys ? this.products : this.hiddenProductDiscounts,
            isHidden: this.showProductCategorys ? false : true
          },
          on: {
            autoComplete: (value: any) => {
              this.autoComplete(value, param);
            },
          },
        });
      },
    },
    {
      text: '订货价',
      value: 'orderPrice',
      sortable: false,
      align: 'right',
      width: 100,
    },
    { text: '折扣价', align: 'left', value: 'discountPrice', sortable: false, isInputNumber: { type: 'isDiscountPrice', symbol: '元' } },
    {
      text: '操作',
      value: 'actions',
      isActions: true,
      sortable: false,
      align: 'center',
    },
  ];

  productCategorys: Array<any> = [{}];
  hiddenProductDiscounts: Array<any> = [{}];
  products: Array<any> = [{}];
  @Prop({ type: Boolean, default: true }) showProductCategorys!: boolean;

  selectedCategory() {
    return this.productCategorys
      .filter((c: any) => {
        return c.id;
      })
      .map((p: any) => {
        return p.id;
      });
  }
  inputHandler(value: any, param: any) {
    if (!value) {
      this.productCategorys.splice(param.index, 1, Object.assign({}, param.row, { count: null, id: null, productCategoryId: null, discountRate: null }));
      return;
    }
    getProductCount({ categoryId: value }).then((data: any) => {
      this.productCategorys.splice(param.index, 1, Object.assign({}, param.row, { count: data, id: value, productCategoryId: value }));
    });
    this.tableChange();
  }

  categoryInput(value: any) {
    this.productCategorys = value;
    this.tableChange();
  }
  productInput(value: any) {
    this.products = value;
    this.tableChange();
  }
  productDiscountsInput(value: any) {
    console.log('productDiscountsInput',value)
    this.hiddenProductDiscounts = value;
    this.tableChange();
  }
  textChange(value: any, param: any, type: string) {
    if (type == 'discountRate') {
      this.productCategorys[param.index][type] = value;
    } else {
      this.products[param.index][type] = value;
    }
    this.tableChange();
  }
  autoComplete(value: any, param: any) {
    this.showProductCategorys ? this.products.splice(param.index, 1, value) : this.hiddenProductDiscounts.splice(param.index, 1, value);
    this.tableChange();
  }
  add(type: string, index: number) {
    if (type == 'productDiscount') {
      this.hiddenProductDiscounts.splice(index + 1, 0, {});
    } else if (type == 'product') {
      this.products.splice(index + 1, 0, {});
    } else {
      this.productCategorys.push({});
    }
    this.tableChange();
  }
  remove(type: string, index: number, key: string) {
    if (type == 'productDiscount') {
      this.hiddenProductDiscounts.splice(index, 1);
      if (this.hiddenProductDiscounts.length < 1) {
        this.hiddenProductDiscounts.push({});
      }
    } else if (type == 'product') {
      this.products.splice(index, 1);
      if (this.products.length < 1) {
        this.products.push({});
      }
    } else {
      this.productCategorys.splice(index, 1);
      if (this.productCategorys.length < 1) {
        this.productCategorys.splice(index, 1, {});
      }
    }
    this.tableChange();
  }

  tableChange() {
    if (this.showProductCategorys) {
      this.$emit('tableChange', { productCategoryDicounts: this.productCategorys, productDiscounts: this.products });
    } else {
      this.$emit('tableChange', { hiddenProductDiscounts: this.hiddenProductDiscounts });
    }
    // this.$emit('tableChange', { productCategoryDicounts: this.productCategorys, productDiscounts: this.products, hiddenProductDiscounts: this.hiddenProductDiscounts });
  }
}
